import { render, staticRenderFns } from "./CustomerSalesReport.vue?vue&type=template&id=657063ba&scoped=true&"
import script from "./CustomerSalesReport.vue?vue&type=script&lang=js&"
export * from "./CustomerSalesReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "657063ba",
  null
  
)

export default component.exports